import script from "./ProductFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFilters.vue?vue&type=script&setup=true&lang=js"

import "./ProductFilters.vue?vue&type=style&index=0&id=1251391a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1251391a"]])

export default __exports__